module.exports = __webpack_public_path__ + "img/EstadoBateriaDispositivoEnActivacion.f874802f.svg";